// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { API_URL_CURRENT_FRAGMENT, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AddProductApiParameter } from "@insite/client-framework/Services/CartService";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

const cartsUrl = "/api/v1/carts";

export async function addProductWithAdditionalParameters(
    parameter: AddProductApiParameter,
): Promise<ServiceResult<CartLineModel>> {
    const cartLine = {
        productId: parameter.productId,
        qtyOrdered: parameter.qtyOrdered,
        unitOfMeasure: parameter.unitOfMeasure,
        notes: parameter.notes,
        sectionOptions: parameter.sectionOptions,
        // XNG-Changes: properties
        properties: {
            lineQuoteRequested: parameter?.additionalQueryStringParameters?.lineQuoteRequested?.toString(),
        } as any,
    } as CartLineModel;

    if (parameter.subscription) {
        cartLine.properties = {
            ...cartLine.properties,
            productSubscription: JSON.stringify(parameter.subscription),
        };
    }

    try {
        const cartLineModel = await post(`${cartsUrl}/${API_URL_CURRENT_FRAGMENT}/cartlines`, cartLine);
        return {
            successful: true,
            result: cartLineModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        if (error.status === 403) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
                statusCode: 403,
            };
        }
        throw error;
    }
}
